import React, { Component } from 'react';
import { GoogleMap, useLoadScript, Marker, useJsApiLoader } from '@react-google-maps/api';


const containerStyle = {
  width: '100%',
  height: '400px'
};



export default function MapAddress({venue}) {


  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAP_API_KEY
  })

  const [map, setMap] = React.useState(null)
  const [centerCoor, setCenterCoor] = React.useState({
    lat: -6.200000,
    lng: 106.816666
  })


  const onLoad = React.useCallback(function callback(map) {
    const geocodeAddress = async (map) => {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            venue.location
          )}&key=${process.env.REACT_APP_MAP_API_KEY}`
        );
        const data = await response.json();
        if (data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          console.log(lat, lng)
          setCenterCoor({ lat: lat, lng: lng });
          setMap(map)
        }
      } catch (error) {
        console.error("Geocoding error:", error);
      }
    };
    if (venue.latitude && venue.longitude) {
      setCenterCoor({ lat: parseFloat(venue.latitude), lng: parseFloat(venue.longitude) })
      setMap(map)
    } else {
      geocodeAddress(map);
  }
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={centerCoor}
      zoom={16}
      onLoad={onLoad}
      onUnmount={onUnmount} 
      scrollwheel={false}
    >
      <Marker position={centerCoor} />

    </GoogleMap>
  ) : <></>
}
